import { useEffect } from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { legalPages, type LegalPageKey } from "../data/legalContent";

/**
 * Carrier and app-store reviewers open these pages directly and read them, so they are ordinary
 * server-addressable routes rather than modals or anchors on the marketing page.
 */
export default function LegalPage({ page }: { page: LegalPageKey }) {
  const { title, updated, sections } = legalPages[page];
  useEffect(() => {
    document.title = `${title} · Subedi Tax Pro`;
  }, [title]);

  return (
    <>
      <Header />
      <main className="legal-page">
        <div className="site-shell">
          <h1>{title}</h1>
          <p className="legal-page__updated">Last updated {updated}</p>
          {sections.map((section) => (
            <section key={section.heading}>
              <h2>{section.heading}</h2>
              {section.body.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
}
